import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './Header.css';
import Nav from "../nav/Nav.jsx";
import Logo from './solero-logo.png';
// import Search from "../search/Search";
import classNames from 'classnames';


/**
 * Header - Global Component
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class Header extends Component {

    /**
     * Default Props
     *
     * @type {{classNames: *}}
     */
    static defaultProps = {
        classNames: classNames('Header', 'Header--bgColor')
    };

    /**
     * Prop Types
     *
     * @type {{classNames: shim}}
     */
    static propTypes = {
        classNames: PropTypes.string
    };

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        const {classNames, location, navList} = this.props;

        return (
            <header className={classNames}>

                {/*LOGOS*/}
                <div className="Header-logo-wrapper">
                    <a href="/"
                       className="Header-logo-short">
                        <img src={Logo}
                             alt=""/>
                    </a>
                    <a href="/"
                       className="Header-logo-long">
                        <img src={Logo}
                             alt=""/>
                    </a>
                </div>

                {/*GLOBAL NAV*/}
                <Nav navList={navList}
                     location={location}/>

            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/header/Header.jsx